import PropTypes from 'prop-types';

const defaultProps = {
  error: null
};

const propTypes = {
  touched: PropTypes.bool.isRequired,
  error: PropTypes.string
};

const FormError = (props) => {
  const { touched, error, id } = props;
  if (touched && error) {
    return (
      <span id={id} className="c7-message--error">
        Error: {error}
      </span>
    );
  }
  return null;
};

FormError.defaultProps = defaultProps;

FormError.propTypes = propTypes;

export default FormError;
